import { FC } from 'react';
import {Link} from "react-router-dom";
import {useLang} from "../../hooks/useLang";

interface IProps {
    to?: string,
    active?: boolean,
    wrapOnly?: boolean,
    children?: any,
    [key: string]: any,
}

export const BreadcrumbItem: FC<IProps> = (props) => {
    const { active, to, wrapOnly, children } = props;
    const { t, lang, getLangPath } = useLang();
    return (
        <>
            {wrapOnly ? (
                <li>children</li>
            )
            : (
                <li>
                    {to ? (
                        <Link to={getLangPath(lang, to)} className={`breadcrumb-link ${active ? 'active' : ''}`}>
                            {t(children)}
                        </Link>
                    ) : (
                        <span className={`breadcrumb-link ${active ? 'active' : ''}`} aria-current="page">{t(children)}</span>
                    )}
                </li>
            )}

        </>
    );
}
